import { render, staticRenderFns } from "./branchDialog.vue?vue&type=template&id=11d80bb2&scoped=true&"
import script from "./branchDialog.vue?vue&type=script&lang=js&"
export * from "./branchDialog.vue?vue&type=script&lang=js&"
import style0 from "./branchDialog.vue?vue&type=style&index=0&id=11d80bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d80bb2",
  null
  
)

export default component.exports